export const HelpDescriptions = {
    CURRENCY_VALUE_LIMTS : `Please indicate the appropriate Value Limits for each Risk Level.
    The value 0 will equal a limit of Zero being applied. An empty value (null) will equal an infinite limit (unlimited)`,
    AUTH_DROP_OFF: `Please indicate the number of days you would like a pending authorisation to drop off after if it's not cleared/settled by the merchant.`,
    TRANSACTION_COUNT_LIMTS : `Please indicate the appropriate Count Limits for each Risk Level
    The value 0 will equal a limit of Zero being applied. An empty value (null) will equal an infinite limit (unlimited)`, 
}